import { AlertWithActionsType } from '@masfront/common-b2c'
import { AnyAction } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { mergeMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import { createOrder, setOrderStatus } from './checkout.reducer'

import { SaleError } from '../model/checkout.model'
import CheckoutService from '../services/checkout.service'

import { RootState } from '~/core/store/root.reducer'

const createOrderEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { checkoutService: CheckoutService }
> = (action$, state$, { checkoutService }) =>
  action$.pipe(
    filter(createOrder.match),
    withLatestFrom(state$),
    mergeMap(([action]) =>
      from(checkoutService.createOrder(action.payload.saleRequest)).pipe(
        map(({ data, status }) =>
          setOrderStatus({
            id: action.payload.id,
            saleResponse: { data, httpStatus: status },
            status: AlertWithActionsType.success,
          }),
        ),
        catchError((error: AxiosError<SaleError>) => {
          if (!error?.response?.status || error?.response?.status !== 500)
            return of(
              setOrderStatus({
                id: action.payload.id,
                saleResponse: { error: error?.response?.data, httpStatus: error?.response?.status },
                status: AlertWithActionsType.warning,
              }),
            )
          return of(
            setOrderStatus({
              id: action.payload.id,
              saleResponse: { error: error?.response?.data, httpStatus: error?.response?.status },
              status: AlertWithActionsType.error,
            }),
          )
        }),
      ),
    ),
  )

const checkoutEpics = {
  createOrderEpic,
}

export default checkoutEpics
